import { useSelector } from 'react-redux';
import axios from 'axios';

// Create an axios instance
const apiHandler = axios.create({
  baseURL: 'https://emsbackend.vigilantvisionsystem.com/ec2/api/v1', // Base URL for the API
});

// Custom hook to get the token and set Authorization header dynamically
export const useApiHandler = () => {
  const token = useSelector((state) => state.token);  // Get token from Redux store
console.log(token)
  // Add request interceptor to include token in the header
  apiHandler.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add a response interceptor to handle errors
  apiHandler.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        console.error('Unauthorized: Token may be expired.');
      }
      return Promise.reject(error);
    }
  );

  return apiHandler;
};
